import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Globe2 } from "lucide-react";

const STATUS_LABELS = {
  idea: "Idee", research: "Cercetare", drafting: "În redactare",
  public_consultation: "Consultare publică", submitted: "Depusă", adopted: "Adoptată", rejected: "Respinsă"
};
const STATUS_COLORS = {
  idea: "text-[#A0AABF]", research: "text-[#A0AABF]", drafting: "text-[#D4A63D]",
  public_consultation: "text-[#D4A63D]", submitted: "text-[#3BA76D]", adopted: "text-[#3BA76D]", rejected: "text-[#C83A3A]"
};

export default function Legislatie() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/legislative").then(r => setItems(r.data || [])).catch(() => {}); }, []);

  return (
    <div data-testid="page-legislatie" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-12">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Policy Lab Civic</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Propuneri legislative</h1>
        <p className="mt-4 text-[#A0AABF] text-lg max-w-3xl">Problemele reale au nevoie de soluții reale. Aceste propuneri sunt evidence-based, balanced, child-first.</p>
      </header>

      <div className="grid md:grid-cols-2 gap-6">
        {items.map(p => (
          <article key={p.leg_id} data-testid={`leg-${p.slug}`} className="cinematic-card rounded-lg p-6 md:p-8">
            <div className="flex items-center justify-between mb-3">
              <span className="text-[10px] uppercase tracking-[0.25em] text-[#D4A63D]">{p.category}</span>
              <span className={`text-[10px] uppercase tracking-[0.25em] ${STATUS_COLORS[p.status]}`}>{STATUS_LABELS[p.status]}</span>
            </div>
            <h3 className="font-display text-xl md:text-2xl text-[#F8F8F4] leading-snug">{p.title}</h3>
            <div className="my-5 gold-divider" />
            <div className="space-y-4 text-sm">
              <div>
                <div className="text-[10px] uppercase tracking-widest text-[#A0AABF] mb-1">Problema</div>
                <p className="text-[#F8F8F4]/90 leading-relaxed">{p.problem}</p>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-[#A0AABF] mb-1">Soluția propusă</div>
                <p className="text-[#F8F8F4]/90 leading-relaxed">{p.proposed_solution}</p>
              </div>
              <div>
                <div className="text-[10px] uppercase tracking-widest text-[#A0AABF] mb-1 flex items-center gap-1.5"><Globe2 className="w-3.5 h-3.5" /> Modele internaționale</div>
                <div className="flex flex-wrap gap-2">
                  {(p.international_models || []).map(m => (
                    <span key={m} className="text-xs px-2 py-1 rounded-sm bg-white/5 border border-white/10 text-[#F8F8F4]/80">{m}</span>
                  ))}
                </div>
              </div>
            </div>
          </article>
        ))}
      </div>
    </div>
  );
}
